<template>
    <div>
      <div class="row mb-3">
        <div class="col-md-12">
            <!-- {{ almacen }} -->
            <h1>ALMACEN {{ almacen.name }}</h1>
          <!-- <router-link
            to="/principal/warehouse/add"
            class="btn btn-secondary"
            v-if="$can('create', 'Enterprise') && almacen.name !== 'CLIENTES'"
          >Agregar Producto</router-link> -->
          <button class="btn btn-secondary"
           @click="$modal.show('addProductWarehouse')"
           v-if="myRoleId === 1"
          >
            Agregar producto
          </button>
          <div class="row justify-content-end mb-4">
              <jsonExcel :data="rows"
                class="btn btn-secondary"
                :fields= "{
                  'Id': 'id_order',
                  'Producto': 'product',
                  'Stock': 'stock',
                  'Costo tienda': 'costo_tienda',
                  'Precio de venta': 'precio',
                  'Precio de Mayoreo': 'venta_mayoreo',
                  'Codigo de barras': 'barcode',
                }"
                worksheet="Reporte de compra"
                name="Reporte de compra.xls"
              >
                Descargar a Excel
              </jsonExcel>
            </div>
        </div>
      </div>
      <vue-good-table
        mode="remote"
        :columns="columns"
        :rows="rows"
        :totalRows="totalRecords"
        :sort-options="{
            enabled: true,
            initialSortBy: [{field: 'name', type: 'asc'}]
          }"
        :isLoading.sync="isLoading"
        styleClass="vgt-table bordered"
        :pagination-options="{
            enabled: true,
            mode: 'registros',
            position: 'top',
            perPage: 10,
            nextLabel: 'siguiente',
            prevLabel: 'anterior',
            rowsPerPageLabel: 'Filas por página',
            ofLabel: 'de',
            pageLabel: 'páginas', // for 'pages' mode
            allLabel: 'Todos',
          }"
        @on-page-change="onPageChange"
        @on-sort-change="onSortChange"
        @on-column-filter="onColumnFilter"
        @on-per-page-change="onPerPageChange"
      >
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'barcode'">
            <input v-if="myRoleId === 1" type="text" class="form-control" v-model="props.row.barcode" @change="change(props)">
            <span v-else>{{ props.row.barcode }}</span>
          </span>
          <span v-else-if="props.column.field == 'config'">
            <button class="btn btn-secondary m-2" @click="openModal(props)" v-if="myRoleId === 1">
              <font-awesome-icon :icon="['fa', 'pencil-alt']" size="1x"/>
            </button>
            <button class="btn btn-danger m-2" @click="deleteO(props.row)" v-if="myRoleId === 1">
              <font-awesome-icon :icon="['fa', 'trash']" size="1x"/>
            </button>
          </span>
        </template>
      </vue-good-table>
      <modal name="addProductWarehouse" :scrollable="true" height="auto" class="">
        <div class="text-right">
          <span class="close-modal" @click="$modal.hide('addProductWarehouse')">
            <font-awesome-icon :icon="['fa', 'times-circle']" />
          </span>
        </div>
        <div class="reset-pass">
          <h2 class="text-center">Nuevo producto</h2>
          <!-- <div class="form-group col-11">
             <label for="exampleInputEmail1">Marca</label>
             <input type="text" class="form-control ml-3" v-model="edit.marca" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Nombre">
          </div> -->
          <div class="form-group col-11">
              <label>Modelo</label>
              <input type="text" class="form-control ml-3" v-model="edit.modelo" placeholder="Modelo">
          </div>
          <!-- <div class="form-group col-11">
              <label>Color</label>
              <input type="text" class="form-control ml-3" v-model="edit.color" placeholder="Descripción breve">
          </div> -->
          <div class="form-group col-11">
              <label>Precio menudeo</label>
              <input type="number" min="0" class="form-control ml-3" v-model="edit.menudeo" placeholder="Precio menudeo">
          </div>
          <div class="form-group col-11">
              <label>Precio mayoreo</label>
              <input type="number" min="0" class="form-control ml-3" v-model="edit.mayoreo" placeholder="Precio mayoreo">
          </div>
          <div class="form-group col-11">
              <label>Proveedor</label>
              <select name="" class="form-control" id="" v-model="edit.provider">
                <option value="null">SELECCIONE UNA OPCIÓN</option>
                <option :value="p.id_provider" v-for="p in providers" :key="p.id_provider">{{ p.name }}</option>
              </select>
          </div>
          <div class="form-group col-11">
              <label>Codigo de barras</label>
              <input type="text" class="form-control ml-3" v-model="edit.barcode" placeholder="Codigo de barras">
          </div>
          <div class="form-group col-11 text-center">
            <button class="btn btn-purple" @click="actualizar">Guardar</button>
          </div>
        </div>
      </modal>
      <modal name="editInfo" :scrollable="true" height="auto" class="">
        <div class="text-right">
          <span class="close-modal" @click="$modal.hide('editInfo')">
            <font-awesome-icon :icon="['fa', 'times-circle']" />
          </span>
        </div>
        <div class="reset-pass">
          <h2 class="text-center">Actualizar producto</h2>
          <!-- <div class="form-group col-11">
             <label for="exampleInputEmail1">Marca</label>
             <input type="text" class="form-control ml-3" v-model="edit.marca" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Nombre">
          </div> -->
          <div class="form-group col-11">
              <label>Producto</label>
              {{ editProduct.product }}
              <input type="text" class="form-control ml-3" v-model="editProduct.marca" placeholder="Marca">
              <input type="text" class="form-control ml-3" v-model="editProduct.modelo" placeholder="Modelo">
              <input type="text" class="form-control ml-3" v-model="editProduct.color" placeholder="Color">
          </div>
          <div class="form-group col-11">
              <label>Costo tienda</label>
              <input type="number" min="0" class="form-control ml-3" v-model="editProduct.costo_tienda" placeholder="Precio menudeo">
          </div>
          <div class="form-group col-11">
              <label>Precio de venta</label>
              <input type="number" min="0" class="form-control ml-3" v-model="editProduct.precio" placeholder="Precio menudeo">
          </div>
          <div class="form-group col-11">
              <label>Precio de mayoreo</label>
              <input type="number" min="0" class="form-control ml-3" v-model="editProduct.venta_mayoreo" placeholder="Precio mayoreo">
          </div>
          <div class="form-group col-11">
              <label>Proveedor</label>
              <select name="" class="form-control" id="" v-model="editProduct.provider_id">
                <option value="null">SELECCIONE UNA OPCIÓN</option>
                <option :value="p.id_provider" v-for="p in providers" :key="p.id_provider">{{ p.name }}</option>
              </select>
          </div>
          <div class="form-group col-11">
              <label>Codigo de barras</label>
              <input type="text" class="form-control ml-3" v-model="editProduct.barcode" placeholder="Codigo de barras">
          </div>
          <div class="form-group col-11 text-center">
            <button class="btn btn-purple" @click="update">Actualizar</button>
          </div>
        </div>
      </modal>
    </div>
  </template>

<script>
import { VueGoodTable } from 'vue-good-table'
import axiosAdelaService from '@/axios/axiosAdelaService'
import formatData from '@/mixins/formatAxios'
import { mapGetters } from 'vuex'
import JsonExcel from 'vue-json-excel'

export default {
  mixins: [formatData],
  components: {
    VueGoodTable,
    JsonExcel
  },
  data () {
    return {
      almacen: [],
      edit: {
        modelo: '',
        menudeo: 0,
        mayoreo: 0,
        barcode: '',
        provider: null
      },
      editProduct: {
        name: '',
        costo_tienda: 0,
        precio_venta: 0,
        precio_mayoreo: 0,
        codigo_barras: ''
      },
      rows: [],
      isLoading: false,
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: {
          field: '',
          type: ''
        },
        page: 1,
        perPage: 10
      },
      columns: [
        {
          label: 'ID',
          field: 'id_order',
          filterOptions: {
            placeholder: 'ID del almacén',
            enabled: true
          }
        },
        {
          label: 'Producto',
          field: 'product',
          filterOptions: {
            placeholder: 'Nombre',
            enabled: true
          }
        },
        {
          label: 'Stock',
          field: 'stock',
          filterOptions: {
            placeholder: 'Stock',
            enabled: true
          }
        },
        {
          label: 'Costo tienda',
          field: 'costo_tienda',
          filterOptions: {
            placeholder: 'Costo',
            enabled: true
          }
        },
        {
          label: 'Precio de Venta',
          field: 'total',
          filterOptions: {
            placeholder: 'Precio',
            enabled: true
          }
        },
        {
          label: 'Precio de Mayoreo',
          field: 'venta_mayoreo',
          filterOptions: {
            placeholder: 'Precio',
            enabled: true
          }
        },
        {
          label: 'Codigo de barras',
          field: 'barcode',
          thClass: 'text-center',
          tdClass: 'text-center'
        },
        {
          label: 'Acciones',
          field: 'config',
          thClass: 'text-center',
          tdClass: 'text-center'
        }
      ],
      providers: []
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser'
    }),
    myRoleId () {
      return this.$store.getters.currentRoleId
    }
  },
  methods: {
    async getProviders () {
      try {
        const request = {
          // data: JSON.stringify(completeRegisters)
        }
        const response = await axiosAdelaService.post('/getProviders', request)
        // console.log('response Enterprises', response.data)
        if (response.status === 200) {
          this.providers = response.data.rows
        }
      } catch (error) {
        console.log(error)
        this.showError('No se pudieron obtener las empresas, por favor intentelo mas tarde')
      }
    },
    go (info) {
      this.$router.push({ name: 'labelsOrders', params: info })
    },
    openModal (prop) {
      const { row } = prop
      // console.log('AQUI', row)
      this.editProduct = row
      this.$modal.show('editInfo')
    },
    async update () {
      try {
        const request = {
          ...this.editProduct
        }
        // console.log(request)
        const orders = await axiosAdelaService.post('/updateOrderWarehouse', request)
        // console.log('getEnterprisesSelected', orders)
        if (orders.status === 200) {
          this.$toastedPush({
            message: 'Producto atualizado..',
            type: 'success'
          })
          this.loadItems(this.$route.params.row.id)
          this.$modal.hide('editInfo')
        }
      } catch (error) {
        this.showError('No se pudo actualizar el almacen, intentelo mas tarde...')
      }
    },
    async deleteO (row) {
      try {
        this.$dialog.confirm(`
          <div class="row justify-content-center">
            <div class="col-lg-11 text-center">
              <h4 style="color:red"><b>Por favor, confirma que deseas eliminar este registro. <br>Esta acción no se podra deshacer...</b></h4>
            </div>
          </div>
        `)
          .then(async () => {
            const request = {
              ...row
            }
            // console.log('ESTO', request)
            const orders = await axiosAdelaService.post('/deleteOrderWarehouse', request)
            // console.log('getEnterprisesSelected', orders)
            if (orders.status === 200) {
              this.$toastedPush({
                message: 'Producto eliminado..',
                type: 'success'
              })
              this.loadItems(this.$route.params.row.id)
              this.$modal.hide('editInfo')
            }
          })
          .catch((err) => {
            console.log('presiono cancelar confirmationDialog', err)
          })
      } catch (error) {
        this.showError('No se pudo actualizar el almacen, intentelo mas tarde...')
      }
    },
    async actualizar () {
      try {
        if (this.edit.provider === null) {
          this.showError('Por favor, seleccione un proveedor')
          return
        }
        if (this.edit.modelo === '') {
          this.showError('Por favor, ingrese un modelo')
          return
        }
        if (this.edit.barcode === '') {
          this.showError('Por favor, ingrese un codigo de barras')
          return
        }
        const request = {
          ...this.edit,
          enterpise: this.user.enterprise_id,
          user_id: this.user.user_admin_id,
          almacen: this.$route.params.row.id
        }
        // console.log(request)
        const orders = await axiosAdelaService.post('/createOrderWarehouse', request)
        // console.log('getEnterprisesSelected', orders)
        if (orders.status === 200) {
          this.$toastedPush({
            message: 'Almacén atualizado..',
            type: 'success'
          })
          this.loadItems(this.$route.params.row.id)
          this.$modal.hide('addProductWarehouse')
        }
      } catch (error) {
        this.showError('No se pudo actualizar el almacen, intentelo mas tarde...')
      }
    },
    updateParams (newProps) {
      this.serverParams = Object.assign({ page: 0 }, this.serverParams, newProps)
    },
    onPageChange (params) {
      this.updateParams({ page: params.currentPage })
      this.loadItems()
    },
    onPerPageChange (params) {
      this.updateParams({ perPage: params.currentPerPage })
      this.loadItems()
    },
    onSortChange (params) {
      this.updateParams({
        sort: {
          type: params[0].type,
          field: params[0].field
        }
      })
      this.loadItems()
    },
    onColumnFilter (params) {
      this.updateParams(params)
      this.loadItems(this.almacen.id)
    },
    async change (props) {
      try {
        const { row } = props
        const params = {
          order_id: row.id_order,
          barcode: row.barcode
        }
        console.log(row, params)
        const response = await axiosAdelaService.post('/updateBarcode', params)
        console.log('getProductsForWarehouse', response)
        // if (response.status === 200) {
        //   this.totalRecords = response.data.totalRecords
        //   this.rows = response.data.rows
        // }
      } catch (error) {
        console.log(error)
        this.showError('No se pudieron obtener las empresas intentalo mas tarde.')
      }
    },
    async loadItems (id) {
      try {
        const params = {
          enterpise: this.user.enterprise_id,
          almacen: id
        }
        const response = await axiosAdelaService.post('/getProductsForWarehouse', params)
        console.log('getProductsForWarehouse', response)
        if (response.status === 200) {
          this.totalRecords = response.data.totalRecords
          this.rows = response.data.rows
        }
      } catch (error) {
        console.log(error)
        this.showError('No se pudieron obtener las empresas intentalo mas tarde.')
      }
    }
  },
  async mounted () {
    const { row } = this.$route.params
    if (row !== undefined) {
      console.log('parametros', row)
      this.loadItems(row.id)
      this.almacen = row
      await this.getProviders()
    }
  }
}
</script>
<style>
</style>
